import { CouponModel } from "./coupon-model";

export class Order 
{
    public PayCardID:string = '';

    public ID:string = '';
    public Number:number = 0;
    public Origin:number = 2;
    public Platform:number = 0;
    public Device:number = 0;
    public Version:string = 'web_app';
    public WaitTime:number = 0;
    public ItemCount:number = 0;
    public Print:boolean = false;
    public SenderID:string = '';
    public NotificationToken:string = '';
    public Timestamp:number = 0;
    public CustomerName:string = '';
    public CustomerPhone:string = '';
    public Table:number = 0;
    public TableToGo:boolean = false;
    public NeedsChange:boolean = false;
    public ChangeFor:string = '';
    public RetrievalMode = '';
    public PaymentMode:number = 0;
    public DeliveryLocationName:string = '';
    public Fee:number = 0;
    public PlaceReference:string = '';
    public Street:string = '';
    public PlaceNumber:string = '';
    public Neighbourhood:string = '';
    public FullAddress:string = '';
    public AddressUrl:string = '';
    public PaidOnline:boolean = false;
    public Status:number = 0;
    public Type:number = -1;
    public IsNew:boolean = true;

    public Removed:boolean = false;

    public Scheduled:boolean = false;
    public Fullfilled:boolean = false;
    public ScheduledTimestamp:number = 0;

    public Coupon:CouponModel | undefined;
}
